import { useContext } from "react";
import { AppContext } from "../context/app.context";

export default function useApp() {
    const context = useContext(AppContext);
    if (!context) {
        throw new Error("useApp must be used within a AppProvider");
    }
    return context
}